module.exports = __webpack_public_path__ + "img/1.bfd63ce8.jpg";